import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-finance-report',
  templateUrl: './finance-report.component.html',
  styleUrls: ['./finance-report.component.scss']
})
export class FinanceReportComponent implements OnInit {
  from_date: any;
  to_date: any;
  pdf_data: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;
  constructor(private httpService: HttpService, private dialog: MatDialog, private dom: DomSanitizer,  private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.generateFinanceReport(data_dict).subscribe((data) => {
      console.log(data);
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    // let w = window.open(linkSource);
    // w.print();
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    // const dialogRef = this.dialog.open(PdfPreviewComponent, {
    //   height: '700px',
    //   width: '700px',
    //   data: {
    //     'pdf': linkSource,
    //     'fileName': fileName
    //   },
    // });
    // dialogRef.afterClosed().subscribe(result => {
    // });
  }

  changeEvent() {
    this.document_file = null;
  }

  ngOnInit() {
  }
}
